module.exports = __webpack_public_path__ + "static/media/26_galeria_plantilla_navidad_combo_duo_rec_motivo_1.971f902e.png";